import React, { useState, useContext, useEffect } from "react";
import BusinessDataValidation from "../helper/BusinessDataValidation";
import axios from "axios";
import { ConfigContext } from "../context/GlobalContext";
import { useNavigate } from "react-router-dom";
import EditBusinessData from "../data/Firebase/Business/EditBusinessDataInFirebase";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getImage } from "../Utils/image_helper";
import { toast } from "react-toastify";
import { EditBusiness } from "../data";
import { Languages } from "../Utils/Languages";
import LoaderView from "./LoaderView";
import Country from "../Utils/countries.json";
import Currancy from "../Utils/currency.json";
import CryptoJS from "crypto-js";

const BusinessEditForm = () => {

  const { state, dispatch } = useContext(ConfigContext);

  const navigate = useNavigate();

  const business_data = state?.BUSINESSES?.find(business => String(business.companyId) === String(state?.SELECTEDBUSINESS));
  const secretKey = process.env.REACT_APP_UPI_SECRET_KEY;
  const isEncrypted = (value) => {
    return typeof value === "string" && value.startsWith("U2FsdGVkX1");
  };

  const decryptUPIIfNeeded = (value) => {
    if (!value) return "";

    try {
      // If not encrypted → return as it is
      if (!isEncrypted(value)) {
        return value;
      }

      const bytes = CryptoJS.AES.decrypt(value, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      return decrypted || value; // fallback safety
    } catch (error) {
      console.error("Decryption failed:", error);
      return value; // fail safe
    }
  };



  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingGst, setIsFetchingGst] = useState(false);
  const [businessData, setBusinessData] = useState({
    companyPhoto: null,
    companyPhotoURL: business_data?.companyPhoto || "",
    companyName: business_data?.companyName || "",
    gstNumber: business_data?.gstNumber || "",
    address: business_data?.address || "",
    companyId: business_data?.companyId || "",
    creationDate: business_data?.creationDate || "",
    isArchive: business_data?.isArchive || "",
    terms: business_data?.terms || "",
    updateDate: new Date().getTime(),
    id: business_data?.id,
    currency: business_data?.currency || "INR",
    upiId: decryptUPIIfNeeded(business_data?.upiId) || ""
  });
  const [currencySearch, setCurrencySearch] = useState("");
  const [error, setError] = useState({
    companyName: null,
  })

  const HandleChangeInBusinessData = (field, value) => {
    setBusinessData((prevData) => ({
      ...prevData,
      [field]: value,
    }));

    setError((prevData) => ({
      ...prevData,
      [field]: null,
    }));
  };

  const fetchGstDetails = async () => {
    if (!businessData.gstNumber || businessData.gstNumber.length < 15) {
      toast.error("Please enter a valid 15-digit GST number.");
      return;
    }

    setIsFetchingGst(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}fetch-gst-data/${businessData.gstNumber}`);

      if (response.data && response.data.status && response.data.data?.taxpayerInfo) {
        const info = response.data.data.taxpayerInfo;

        const addr = info.pradr?.addr || {};
        const addressParts = [
          addr.bno,
          addr.bnm,
          addr.st,
          addr.loc,
          addr.dst,
          addr.stcd,
        ].filter(part => part && part.toString().trim() !== "");

        let finalAddress = addressParts.join(", ");
        if (addr.pncd) {
          finalAddress += ` - ${addr.pncd}`;
        }

        setBusinessData((prev) => ({
          ...prev,
          companyName: info.tradeNam || info.lgnm || prev.companyName,
          address: finalAddress || prev.address,
        }));

        toast.success("Business details fetched successfully!");
      } else {
        toast.error(response.data?.message || "Taxpayer details not found for this GST number.");
      }
    } catch (error) {
      console.error("GST Fetch Error:", error);
      toast.error("Failed to fetch GST details. This GST number might be invalid or the API is unavailable.");
    } finally {
      setIsFetchingGst(false);
    }
  };

  const [filteredCountries, setFilteredCountries] = useState(Currancy.CountryCurrencyResponse);
  const [selectedItem, setSelectedItem] = useState(null);
  const [field, setField] = useState(false);

  const TaxType = () => {
    let taxType = "TAX";
    const VAT_CURRENCIES = ["EUR", "CZK", "DKK", "HUF", "PLN", "RON", "SEK", "GBP"];
    const GST_CURRENCIES = ["INR", "AUD"];
    const ABN_CURRENCIES = [];
    const SST_CURRENCIES = ["MYR"];
    const CAD_CURRENCIES = ["CAD"];
    if (VAT_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "VAT";
    else if (GST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST";
    else if (ABN_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "ABN";
    else if (SST_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "SST";
    else if (CAD_CURRENCIES.includes(state?.CURRENCYCODE)) taxType = "GST/HST";

    dispatch({ type: 'TAXTYPE', payload: taxType });
  };

  useEffect(() => {
    TaxType();
  }, [state?.CURRENCYCODE]);
  const storedCurrencyCode = businessData?.currency || state?.CURRENCYCODE || state?.SET_USER?.currency;

  useEffect(() => {
    const matchedCurrency = Currancy.CountryCurrencyResponse.find(
      (c) => c.currencyCode === storedCurrencyCode
    );
    if (matchedCurrency) {
      setSelectedItem(matchedCurrency);
    }
    setFilteredCountries(Currancy.CountryCurrencyResponse);

    if (
      (state?.SET_USER?.social_id?.includes('+'))
    ) {
      setField(true);
    } else {
      setField(false)
    }
  }, [state?.SET_USER]);


  const currencyOptions = filteredCountries.map(row => {
    const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === row.countryCode);
    return {
      value: row.currencyCode,
      label: (
        <div className="d-flex align-items-center gap-2">
          <img
            src={
              country?.flag
                ? `data:image/png;base64,${country.flag}`
                : getImage("euro_flag")
            }
            alt="flag"
            width="25"
            height="15"
          />

          <span>{row.name} ({row.currencyCode} - {row.currencytSymbol})</span>
        </div>
      ),
      raw: row,
    };
  });
  const encryptUPI = (upi) => {
    return CryptoJS.AES.encrypt(upi, secretKey).toString();
  };


  const handleItemClick = (result) => {
    setSelectedItem(result);
    // dispatch({ type: 'SYMBOL', payload: result.currencytSymbol });
    // dispatch({ type: 'CURRENCYCODE', payload: result.currencyCode });
    // dispatch({ type: 'CURRENCYNAME', payload: result.name });
    setBusinessData((prevData) => ({
      ...prevData,
      currency: result.currencyCode,
    }));
    const country = Country.CurrencyResponse.find(c => c.isoAlpha2 === result.countryCode);
    if (country) {
      dispatch({ type: 'FLAG', payload: country.flag });
    }
  };
  const OnUpdatePress = async () => {
    const { isValid, errors } = BusinessDataValidation(businessData);

    if (isValid) {
      setIsLoading(true)
      let encryptedBusinessData = { ...businessData };

      // Encrypt sensitive fields
      if (businessData.upiId) {
        // Encrypt only if not already encrypted
        if (!isEncrypted(businessData.upiId)) {
          encryptedBusinessData.upiId = encryptUPI(businessData.upiId);
        } else {
          encryptedBusinessData.upiId = businessData.upiId;
        }
      }

      const { success, message } = await EditBusiness(state, dispatch, encryptedBusinessData);
      if (success && message == "Company data updated successfully!") {

        setIsLoading(false)
        navigate(-1)
        toast.success(Languages[state?.LANGUAGE]?.business_edit_success_message)
      }
      else {
        setIsLoading(false)
        toast.success(Languages[state?.LANGUAGE]?.business_edit_failed_message)
      }

    }
    else {
      console.log(errors);
      setError(errors)
    }

  }
  const selectedCurrencyOption = currencyOptions.find(
    (opt) => opt.raw.currencyCode === selectedItem?.currencyCode
  );

  const [filteredCurrencyOptions, setFilteredCurrencyOptions] = useState(currencyOptions);

  const handleCurrencySearch = (e) => {
    const value = e.target.value;
    setCurrencySearch(value);

    const trimmed = value.trim().toLowerCase();

    if (trimmed === "") {
      setFilteredCurrencyOptions(currencyOptions);
    } else {
      const filtered = currencyOptions.filter((opt) => {
        const label = String(opt.label || "").toLowerCase();
        const value = String(opt.value || "").toLowerCase();
        const country = String(opt.raw?.name || "").toLowerCase();

        return (
          label.includes(trimmed) ||
          value.includes(trimmed) ||
          country.includes(trimmed)
        );
      });

      setFilteredCurrencyOptions(filtered);
    }
  };


  return (
    <div className="card shadow-lg p-4 w-80 mt-3">
      <div className="card-header">

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
          {/* Left Side - Back/Close Button */}
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={() => { navigate(-1) }}
            >
              <i class="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
            </button>
            <p className='fw-semibold mb-0' style={{ fontSize: 20 }}>{Languages[state?.LANGUAGE].edit_business}</p>
          </div>

          {/* Right Side - Other Buttons */}
          <div className="d-flex gap-2">
          </div>
        </div>

      </div>
      <div className="card-body">
        <div className="row">
          <form>
            <div className="row">
              <div className="col-sm-12 col-md-3 text-center">
                <label className="form-label">
                  {Languages[state?.LANGUAGE]?.business_logo}
                </label>
                {/* Image Preview */}
                <div className="mb-3 mt-3">
                  {(businessData.companyPhoto || businessData.companyPhotoURL) ? (
                    <label
                      htmlFor="file"
                      className="position-relative d-inline-block image-container"
                    >
                      <div className="position-relative">
                        {/* Image Preview */}
                        <img
                          id="preview"
                          className="img-fluid rounded-circle shadow-sm image-hover"
                          alt="Company Logo"
                          src={businessData.companyPhoto ? URL.createObjectURL(businessData.companyPhoto) : businessData.companyPhotoURL}
                          style={{
                            width: "160px",
                            height: "160px",
                            objectFit: "cover",
                            cursor: "pointer",
                            transition: "opacity 0.3s ease-in-out",
                          }}
                        />

                        {/* Overlay Effect */}
                        <div className="image-overlay position-absolute top-0 start-0 w-100 h-100 rounded-circle"></div>

                        {/* Edit Icon on Hover */}
                        <div className="edit-icon position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center">
                          <Icon
                            icon="lucide:edit"
                            width="30"
                            height="30"
                            color="white"
                          />
                        </div>
                      </div>
                    </label>
                  ) : (
                    <label htmlFor="file">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle shadow-mg"
                        style={{
                          width: "150px",
                          height: "150px",
                        }}
                      >
                        < img
                          src={getImage("businessform")}
                          style={{
                            width: "80px",
                            height: "80px",
                          }}
                        />
                      </div>
                    </label>
                  )}

                  <input
                    type="file"
                    id="file"
                    name="companyPhoto"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      HandleChangeInBusinessData(
                        "companyPhoto",
                        e.target.files[0]
                      );
                    }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-9">
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">{Languages[state?.LANGUAGE]?.business_name}<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className={`form-control wizard-required ${error.companyName ? "border-danger" : ""}`}
                      placeholder={Languages[state?.LANGUAGE]?.enter_business_name}
                      value={businessData.companyName}
                      onChange={(e) => HandleChangeInBusinessData("companyName", e.target.value)}
                    />
                    {error.companyName && <div className="text-danger small mt-1">{Languages[state?.LANGUAGE]?.business_name_error}</div>}
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">{(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD" || state?.TAXTYPE === "ABN") ? "ABN Number" : `${state?.TAXTYPE} Number`}</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Enter ${(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD" || state?.TAXTYPE === "ABN") ? "ABN" : (state?.TAXTYPE || 'Tax')} Number`}
                        value={businessData.gstNumber}
                        onChange={(e) => HandleChangeInBusinessData("gstNumber", (state?.TAXTYPE === "GST" && !(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD")) ? e.target.value.toUpperCase() : e.target.value)}
                      />
                      {state?.TAXTYPE === "GST" && !(businessData.currency === "AUD" || state?.CURRENCYCODE === "AUD") && (
                        <button
                          type="button"
                          className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1 px-20"
                          onClick={fetchGstDetails}
                          disabled={isFetchingGst}
                        >
                          {isFetchingGst ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          ) : (
                            <>
                              <Icon icon="solar:globus-search-bold" width="18" />
                              Fetch
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Select Country</label>
                    <div className="dropdown">
                      <button
                        className="btn btn-outline-primary-600 dropdown-toggle w-100 d-flex justify-content-between align-items-center px-16 py-10 rounded"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span>{selectedCurrencyOption?.label || "Select Currency"}</span>
                        <i className="bi bi-chevron-down"></i> {/* or use your preferred icon */}
                      </button>
                      <ul
                        className="dropdown-menu w-100 mt-1 shadow-sm border-0 rounded-3 text-center hide-scrollbar"
                        style={{ padding: 0 }}
                      >
                        {/* 🔍 Sticky Search */}
                        <li className="py-2 sticky-top z-1">
                          <input
                            type="text"
                            className="form-control countrybackground"
                            placeholder="Search currency..."
                            value={currencySearch}
                            onChange={handleCurrencySearch}
                          />
                        </li>

                        {/* 🌍 Scrollable list */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }} className="hide-scrollbar">
                          {filteredCurrencyOptions.length > 0 ? (
                            filteredCurrencyOptions.map((option) => (
                              <li key={option.id}>
                                <a
                                  href="#"
                                  className={`dropdown-item d-flex align-items-center gap-2 px-16 py-10 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${selectedCurrencyOption?.value === option.value ? "bg-primary-50 fw-semibold" : ""
                                    }`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleItemClick(option.raw);
                                    setCurrencySearch("");
                                  }}
                                >
                                  {option.label}
                                  {selectedCurrencyOption?.value === option.value && (
                                    <i className="bi bi-check2 text-primary-600 ms-auto"></i>
                                  )}
                                </a>
                              </li>
                            ))
                          ) : (
                            <li className="text-muted text-center small py-2">No Country found</li>
                          )}
                        </div>
                      </ul>
                    </div>
                  </div>

                  {storedCurrencyCode == "INR" && (
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">
                        Your UPI ID
                      </label>
                      <input
                        type="text"
                        className={`form-control wizard-required ${error.upiId ? "border-danger" : ""}`}
                        placeholder={Languages[state?.LANGUAGE]?.enter_upi_id || "Enter UPI ID (e.g., name@upi)"}
                        value={businessData.upiId || ""}
                        onChange={(e) => HandleChangeInBusinessData("upiId", e.target.value)}
                      />
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">{Languages[state?.LANGUAGE]?.address}</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder={Languages[state?.LANGUAGE]?.enter_address}
                    value={businessData.address}
                    onChange={(e) => HandleChangeInBusinessData("address", e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>

            <div>
              {/* Terms & Conditions */}
              <div className="mb-3">
                <label className="form-label">{Languages[state?.LANGUAGE]?.tc_account_details}</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder={Languages[state?.LANGUAGE]?.enter_tc_account_details}
                  value={businessData.terms}
                  onChange={(e) =>
                    HandleChangeInBusinessData("terms", e.target.value)
                  }
                ></textarea>
              </div>
            </div>

            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
              <div className="d-flex gap-2 ">
                <button
                  type="reset"
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                >
                  {Languages[state?.LANGUAGE]?.back}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                  onClick={OnUpdatePress}
                >
                  {Languages[state?.LANGUAGE]?.update}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {isLoading && <LoaderView />}
    </div>

  );
};

export default BusinessEditForm;
